document.addEventListener("DOMContentLoaded", function(){

/* =============================
HELPERS
============================= */

function getHandle(path){
let m = path.match(/products\/([^\/\?]+)/);
return m ? m[1] : null;
}

function normalizeFamily(str){
if(!str) return null;
return str.replace(/\s+/g,'').toLowerCase().trim();
}

/* =============================
VARIANT MAP (VERY IMPORTANT)
============================= */

window.variantMap = {};

window.paperMatrix.forEach(p=>{
let v = new URL(p.url, location.origin).searchParams.get("variant");
if(v){
window.variantMap[v] = p;
}
});

/* =============================
STATE
============================= */

const buttons = document.querySelectorAll(".paper-btn");

let state = {
paper_type:null,
size:null,
quantity:null,
tips:null
};

/* =============================
FAMILY DETECTION
============================= */

let selector = document.querySelector("#paperSelector");

let currentFamily = normalizeFamily(
selector?.dataset.paperFamily
);

if(!currentFamily){

let currentHandle = getHandle(location.pathname);

for(let p of window.paperMatrix){

let h = getHandle(new URL(p.url).pathname);
if(!h) continue;

if(
currentHandle === h ||
currentHandle?.includes(h) ||
h.includes(currentHandle)
){
currentFamily = p.paper_type.replace("vintage-","");
break;
}

}

}

let familyProducts = window.paperMatrix.filter(p =>
p.paper_type.replace("vintage-","") === currentFamily
);

/* =============================
ACTIVE UI
============================= */

function updateActiveUI(){

buttons.forEach(b=>b.classList.remove("active"));

buttons.forEach(btn=>{

let type = btn.dataset.type;
let value = btn.dataset.value;

if(type==="paper_type"){

if(value==="vintage"){
if(state.paper_type?.startsWith("vintage-")){
btn.classList.add("active");
}
}else{
let base = state.paper_type?.replace("vintage-","");
if(base===value){
btn.classList.add("active");
}
}

}

if(type==="size" && state.size===value) btn.classList.add("active");
if(type==="quantity" && state.quantity===value) btn.classList.add("active");
if(type==="tips" && state.tips===value) btn.classList.add("active");

});

}

/* =============================
AUTO DETECT CURRENT (VARIANT BASED)
============================= */

function detectCurrent(){

let variantId =
new URLSearchParams(location.search).get("variant") ||
document.querySelector('[name="id"]')?.value;

if(!variantId) return;

let match = window.variantMap[variantId];
if(!match) return;

state.paper_type = match.paper_type;
state.size       = match.size;
state.quantity   = match.quantity;
state.tips       = match.tips;

updateActiveUI();
updateDisabled();
updateTipsImages();

}

/* =============================
DISABLE ENGINE
============================= */

function updateDisabled(){

buttons.forEach(btn=>{

let type = btn.dataset.type;
let value = btn.dataset.value;
let possible = true;

if(type==="paper_type"){
btn.classList.remove("disabled");
return;
}

if(type==="size"){

possible = familyProducts.some(p =>
p.paper_type===state.paper_type &&
p.size===value
);

}

if(type==="quantity"){

possible = familyProducts.some(p =>
p.paper_type===state.paper_type &&
p.size===state.size &&
p.quantity===value
);

}

if(type==="tips"){

possible = familyProducts.some(p =>
p.paper_type===state.paper_type &&
p.size===state.size &&
p.quantity===state.quantity &&
p.tips===value
);

}

btn.classList.toggle("disabled", !possible);

});

}

/* =============================
MATCH ENGINE
============================= */

function findMatch(sel){

return familyProducts.find(p =>
p.paper_type===sel.paper_type &&
p.size===sel.size &&
p.quantity===sel.quantity &&
p.tips===sel.tips
) || familyProducts[0];

}

/* =============================
CLICK
============================= */

buttons.forEach(btn=>{

btn.addEventListener("click", function(){

if(this.classList.contains("disabled") ||
this.classList.contains("active")) return;

let type = this.dataset.type;
let value = this.dataset.value;

if(type==="paper_type"){

 let currentBase = state.paper_type?.replace("vintage-","");

 /* â­ determine target base */
 let targetBase =
  value === "vintage"
   ? currentBase
   : value;

 /* â­ determine full target paper_type */
 let targetType =
  value === "vintage"
   ? "vintage-" + currentBase
   : value;

 /* â­ update family scope */
 familyProducts = window.paperMatrix.filter(p =>
  p.paper_type.replace("vintage-","") === targetBase
 );

 /* â­ TRY FULL PRESERVE */
 let preserve = familyProducts.find(p =>
  p.paper_type === targetType &&
  p.size === state.size &&
  p.quantity === state.quantity &&
  p.tips === state.tips
 );

 /* â­ TRY PRESERVE SIZE */
 if(!preserve){
  preserve = familyProducts.find(p =>
   p.paper_type === targetType &&
   p.size === state.size
  );
 }

 /* â­ TRY ONLY PAPER TYPE */
 if(!preserve){
  preserve = familyProducts.find(p =>
   p.paper_type === targetType
  );
 }

 /* â­ FINAL FALLBACK */
 if(!preserve){
  preserve = familyProducts[0];
 }

 state.paper_type = preserve.paper_type;
 state.size       = preserve.size;
 state.quantity   = preserve.quantity;
 state.tips       = preserve.tips;

}else{
state[type]=value;
}

updateActiveUI();
updateDisabled();
updateTipsImages();

let match = findMatch(state);

if(match){

let currentVariant =
new URLSearchParams(location.search).get("variant");

let targetVariant =
new URL(match.url, location.origin)
.searchParams.get("variant");

if(currentVariant !== targetVariant){
location.href = match.url;
}

}

});

});

/* =============================
TIPS IMAGE
============================= */

function updateTipsImages(){

if(!state.paper_type) return;

let data = window.paperTypeTipsImages[state.paper_type];
if(!data) return;

let papersBtn = document.querySelector('[data-value="papers-only"] img');
let tipsBtn   = document.querySelector('[data-value="with-tips"] img');

if(papersBtn) papersBtn.src = data.papersOnly;
if(tipsBtn) tipsBtn.src = data.withTips;

}

/* =============================
INIT
============================= */

detectCurrent();
updateDisabled();

});
